import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Navbar } from "./components/Navbar";
import { Footer } from "./components/Footer";
import { CallFab } from "./components/CallFab";
import { WinterFlyer } from "./components/WinterFlyer";
import Home from "./pages/Home";
import About from "./pages/About";
import Treats from "./pages/Treats";
import Birthday from "./pages/Birthday";
import ReadingTree from "./pages/ReadingTree";
import Gallery from "./pages/Gallery";
import FAQ from "./pages/FAQ";
import Contact from "./pages/Contact";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

const useLenis = () => {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.1, smoothWheel: true });
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);
};

function App() {
  useLenis();
  return (
    <BrowserRouter>
      <ScrollToTop />
      <div className="flex min-h-screen flex-col">
        <Navbar />
        <main className="flex-1">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/treats" element={<Treats />} />
            <Route path="/birthday-parties" element={<Birthday />} />
            <Route path="/reading-tree" element={<ReadingTree />} />
            <Route path="/gallery" element={<Gallery />} />
            <Route path="/faq" element={<FAQ />} />
            <Route path="/contact" element={<Contact />} />
          </Routes>
        </main>
        <Footer />
        <WinterFlyer />
        <CallFab />
      </div>
    </BrowserRouter>
  );
}

export default App;
